function getTid(): string {
  return window.location.pathname.split('/')[4] || '';
}

export default getTid;
